import { useMediaQuery } from "@mui/material";

export const useMediaVariants = () => {
	const isMobile = useMediaQuery('(max-width: 600px)');
	const isPrint = useMediaQuery('print');

	return { isMobile, isDesktop: !isMobile, isPrint }
}
